<template>
  <div
    class="content-block company-block"
    data-aos="fade-up"
    data-aos-duration="800"
  >
    <div class="block-left">
      <div class="block-number">06</div>
      <BlockHeader
        title="公司简介"
        subtitle="依托集团，深耕实业"
        subtitleEn="COMPANY PROFILE"
      />
      <div class="block-ornament">
        <div class="ornament-item"></div>
        <div class="ornament-item"></div>
        <div class="ornament-item"></div>
      </div>
    </div>
    <div class="block-right">
      <div class="block-content">
        <p class="block-desc">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          浙江丰沃国际贸易有限公司作为集团重要成员，秉承集团实业发展的核心战略，
          融汇传统匠心与现代创新，致力于成为食品产业的引领者。公司以深厚的行业积淀为基石，通过多品牌运营与全产业链布局，
          为消费者与合作伙伴持续提供健康、优质的产品。
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          其核心品牌——浙江老字号“太丰”，历经近百年历史传承，推陈出新。太丰重视自主研发，建立了自有工厂、实验室和研发团队，通过了ISO22000、HACCP体系等认证，获得多项发明专利。
          近年来，太丰成功转型休闲食品领域，通过“达人带货+抖音直播”等多元化营销，核心产品牛肉干在抖音电商排行榜位列TOP1。
        </p>

        <div class="company-features">
          <div class="feature-item">
            <div class="feature-icon">
              <i class="fas fa-rocket"></i>
            </div>
            <div class="feature-content">
              <h4>创新驱动</h4>
              <p>持续研发投入，技术创新领先行业</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-icon">
              <i class="fas fa-users"></i>
            </div>
            <div class="feature-content">
              <h4>精英团队</h4>
              <p>汇集行业顶尖人才，专业服务客户</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-icon">
              <i class="fas fa-globe"></i>
            </div>
            <div class="feature-content">
              <h4>全球布局</h4>
              <p>业务覆盖30+国家，服务全球客户</p>
            </div>
          </div>
        </div>
      </div>
      <div class="block-footer">
        <router-link :to="{ name: 'Company' }" class="block-btn">
          <span>了解详情</span>
          <i class="fas fa-arrow-right"></i>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import BlockHeader from "../common/BlockHeader.vue";

export default {
  components: { BlockHeader },
  name: "CompanyBlock",
};
</script>

<style scoped>
.company-block {
  display: flex;
  background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);
  border-radius: 15px;
  margin-bottom: 40px;
  border: 1px solid rgba(154, 27, 30, 0.1);
  box-shadow: 0 8px 25px rgba(154, 27, 30, 0.08);
  overflow: hidden;
  position: relative;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.company-block:hover {
  transform: translateY(-5px);
  border-color: rgba(154, 27, 30, 0.3);
  box-shadow: 0 15px 35px rgba(154, 27, 30, 0.12);
}

.company-block .block-left {
  flex: 0 0 280px;
  padding: 35px 25px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, rgba(154, 27, 30, 0.05), transparent);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-right: 1px solid rgba(154, 27, 30, 0.1);
}

.company-block .block-number {
  position: absolute;
  top: 15px;
  left: 15px;
  font-size: 3.5rem;
  font-weight: 900;
  color: rgba(154, 27, 30, 0.05);
  z-index: 0;
}

.company-block .block-ornament {
  position: absolute;
  bottom: 25px;
  display: flex;
  gap: 6px;
}

.company-block .ornament-item {
  width: 3px;
  height: 18px;
  background: linear-gradient(to top, #9a1b1e, transparent);
  border-radius: 1.5px;
}

.company-block .ornament-item:nth-child(2) {
  height: 24px;
  background: linear-gradient(to top, #b22222, transparent);
}

.company-block .ornament-item:nth-child(3) {
  height: 20px;
  background: linear-gradient(to top, #d32f2f, transparent);
}

.company-block .block-right {
  flex: 1;
  padding: 35px 30px;
  position: relative;
  z-index: 1;
}

.company-block .block-content {
  margin-bottom: 25px;
}

.company-block .block-desc {
  font-size: 1rem;
  line-height: 1.7;
  color: #444;
  margin-bottom: 25px;
  text-align: justify;
}

.company-block .company-features {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
  margin-top: 25px;
}

.company-block .feature-item {
  background: white;
  border-radius: 10px;
  padding: 18px;
  border: 1px solid rgba(154, 27, 30, 0.08);
  transition: all 0.3s;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.02);
}

.company-block .feature-item:hover {
  background: rgba(154, 27, 30, 0.03);
  border-color: rgba(154, 27, 30, 0.2);
  transform: translateY(-3px);
  box-shadow: 0 6px 15px rgba(154, 27, 30, 0.08);
}

.company-block .feature-icon {
  width: 45px;
  height: 45px;
  background: linear-gradient(135deg, #9a1b1e, #b22222);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.company-block .feature-icon i {
  font-size: 1.3rem;
  color: white;
}

.company-block .feature-content h4 {
  font-size: 1.1rem;
  color: #222;
  margin-bottom: 5px;
  font-weight: 600;
}

.company-block .feature-content p {
  font-size: 0.85rem;
  color: #666;
  line-height: 1.5;
}

.company-block .block-footer {
  display: flex;
  justify-content: flex-end;
}

.company-block .block-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #9a1b1e, #b22222);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 50px;
  cursor: pointer;
  font-weight: 700;
  transition: all 0.3s;
  font-size: 0.95rem;
  letter-spacing: 0.5px;
  box-shadow: 0 8px 20px rgba(154, 27, 30, 0.2);
  position: relative;
  overflow: hidden;
  text-decoration: none;
}

.company-block .block-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s;
}

.company-block .block-btn:hover {
  transform: translateX(5px);
  box-shadow: 0 12px 30px rgba(154, 27, 30, 0.3);
  color: white;
  text-decoration: none;
  background: linear-gradient(135deg, #b22222, #d32f2f);
}

.company-block .block-btn:hover::before {
  left: 100%;
}

.company-block .block-btn i {
  transition: transform 0.3s;
}

.company-block .block-btn:hover i {
  transform: translateX(5px);
}

@media (max-width: 1200px) {
  .company-block .block-left {
    flex: 0 0 250px;
  }

  .company-block .company-features {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 992px) {
  .company-block {
    flex-direction: column;
  }

  .company-block .block-left {
    flex: 0 0 auto;
    padding: 30px 25px;
    border-right: none;
    border-bottom: 1px solid rgba(154, 27, 30, 0.1);
  }

  .company-block .block-right {
    padding: 30px 25px;
  }
}

@media (max-width: 768px) {
  .company-block .block-left {
    padding: 25px 20px;
  }

  .company-block .block-right {
    padding: 25px 20px;
  }

  .company-block .block-title {
    font-size: 1.6rem;
  }

  .company-block .company-features {
    grid-template-columns: 1fr;
  }

  .company-block .block-btn {
    width: 100%;
    justify-content: center;
  }
}

.company-block::after {
  content: "";
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200px;
  height: 200px;
  background: radial-gradient(
    circle,
    rgba(154, 27, 30, 0.03) 0%,
    transparent 70%
  );
  z-index: 0;
}

.company-block > * {
  position: relative;
  z-index: 1;
}
</style>
